import * as R from "ramda";
import React, { Component } from "react";
import FlexView from "react-flexview";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import ModalContainer from "../../../../../modules/commons/ModalContainer";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import withFormGroup from "../../../../../modules/commons/withFormGroup";
import SimpleModal from "../../../../../modules/popup/SimpleModal";
import Api from "../../../../../Services/Api";
import { fetchDataAsync } from "../../../../../Services/Utils";
import { ACTIVITY_TYPE } from "../../../../common/Constants";
import { flattenFormGroupObject, mapToObjectDDL, mapToSelectOption } from "../../../../common/mapper";
import CrmKTP from "../../components/crmKTP";
import CrmMember from "../../components/crmMember";
import CrmSystem from "../../components/crmSystem";
import CrmTambahan from "../../components/crmTambahan";
import {
  loyaltyLevelOptions,
  memberLevelOptions,
  prospekCategoryOptions,
  prospekSourceOptions,
  prospekTypeOptions,
  specialCategoryOptions,
} from "../constants";
import CrmFollowUpHistory from "./crmFollowUpHistory";
import { constructPayloadSubmit } from "../utils";
import SimpleAlert from "../../../../../modules/popup/SimpleAlert";

class CrmFollowUpH23Modifying extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      options: {
        provinceOptions: [],
        kabkotOptions: [],
        kecamatanOptions: [],
        kelurahanOptions: [],
        zipCodeOptions: [],
        zipCodeRaw: [],
        genderOptions: [],
        religionOptions: [],
        jobOptions: [],
        hobbyOptions: [],
        interestOptions: [],
        hobbyRaw: [],
        interestRaw: [],
        prospekSourceCreateOptions: [],
        prospekCategoryOptions,
        prospekSourceOptions,
        prospekTypeOptions,
        memberLevelOptions,
        loyaltyLevelOptions,
        specialCategoryOptions,
      },
      alertInfo: {
        title: null,
        content: null,
        type: null,
        additionalData: null,
      },
    };
  }

  componentDidMount() {
    this.setDataOptions(
      "prospekSourceCreateOptions",
      prospekSourceOptions
    );
    this.fetchDataProvince();
    this.fetchBizpar();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const currControls = this.props.controls;
    const prevControls = prevProps.controls;
    const { options } = this.state;
    const { setValue } = this.props;

    if (
      prevControls?.provinceId?.value?.value !==
      currControls.provinceId?.value?.value
    ) {
      this.setDataOptions("kabkotOptions", []);
      this.setDataOptions("kecamatanOptions", []);
      this.setDataOptions("kelurahanOptions", []);
      this.setDataOptions("zipCodeOptions", []);
      this.setDataOptions("zipCodeRaw", []);

      setValue("kabkotId", null);
      setValue("kecamatanId", null);
      setValue("kelurahanId", null);
      setValue("zipcode", null);
      this.fetchDataKabKot(currControls.provinceId?.value?.value);
    }
    if (
      prevControls?.kabkotId?.value?.value !==
      currControls.kabkotId?.value?.value
    ) {
      console.log("here");
      this.setDataOptions("kecamatanOptions", []);
      this.setDataOptions("kelurahanOptions", []);
      this.setDataOptions("zipCodeOptions", []);
      this.setDataOptions("zipCodeRaw", []);

      setValue("kecamatanId", null);
      setValue("kelurahanId", null);
      setValue("zipcode", null);
      this.fetchDataKecamatan(currControls.kabkotId?.value?.value);
    }
    if (
      prevControls?.kecamatanId?.value?.value !==
      currControls.kecamatanId?.value?.value
    ) {
      this.setDataOptions("kelurahanOptions", []);
      this.setDataOptions("zipCodeOptions", []);
      this.setDataOptions("zipCodeRaw", []);

      setValue("kelurahanId", null);
      setValue("zipcode", null);
      this.fetchDataKelurahan(currControls.kecamatanId?.value?.value);
    }
    if (
      prevControls?.kelurahanId?.value?.value !==
        currControls.kelurahanId?.value?.value &&
      !R.isEmpty(options.zipCodeRaw)
    ) {
      const data = options.zipCodeRaw.find(
        (item) => item.id === currControls.kelurahanId?.value?.value
      );
      this.setDataOptions(
        "zipCodeOptions",
        !R.isEmpty(data) ? [mapToObjectDDL(data.zipcode, data.zipcode)] : []
      );
    }
  }

  fetchDataProvince = async () => {
    try {
      const response = await Api.create("NAGAMAS_MASTER_DATA").getAllProvince();
      if (response.ok && !R.isEmpty(response.data.data)) {
        this.setDataOptions(
          "provinceOptions",
          response.data.data.map((item) =>
            mapToObjectDDL(item.provinceName, item.id)
          )
        );
      }
    } catch (e) {
      console.log("errors", e);
    }
  };

  fetchDataKabKot = async (id) => {
    try {
      const response = await Api.create("NAGAMAS_MASTER_DATA").getAllCity(id);
      if (response.ok && !R.isEmpty(response.data.data)) {
        this.setDataOptions(
          "kabkotOptions",
          response.data.data.map((item) =>
            mapToObjectDDL(item.kabKotName, item.kabKotId)
          )
        );
      }
    } catch (e) {
      console.log("errors", e);
    }
  };

  fetchDataKecamatan = async (id) => {
    try {
      const response = await Api.create("NAGAMAS_MASTER_DATA").getAllKecamatan(
        id
      );
      if (response.ok && !R.isEmpty(response.data.data)) {
        this.setDataOptions(
          "kecamatanOptions",
          response.data.data.map((item) =>
            mapToObjectDDL(item.kecamatanName, item.id)
          )
        );
      }
    } catch (e) {
      console.log("errors", e);
    }
  };

  fetchDataKelurahan = async (id) => {
    try {
      const response = await Api.create("NAGAMAS_MASTER_DATA").getAllKelurahan(
        id
      );
      if (response.ok && !R.isEmpty(response.data.data)) {
        this.setDataOptions(
          "kelurahanOptions",
          response.data.data.map((item) =>
            mapToObjectDDL(item.kelurahanname, item.id)
          )
        );
        this.setDataOptions("zipCodeRaw", response.data.data);
      }
    } catch (e) {
      console.log("errors", e);
    }
  };

  fetchBizpar = async () => {
    const { onTriggerLoading, setError } = this.props;

    onTriggerLoading();
    const menuName = "CRM - Follow Up Prospect";
    const responses = await Promise.all([
      fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllBizparByParam,
        setError: setError,
        menuName: menuName,
        args: { paramFilters: { bizparCategory: "GENDER_TYPE" } },
      }),
      fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllBizparByParam,
        setError: setError,
        menuName: menuName,
        args: { paramFilters: { bizparCategory: "RELIGION_TYPE" } },
      }),
      fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllBizparByParam,
        setError: setError,
        menuName: menuName,
        args: { paramFilters: { bizparCategory: "JOB_TYPE" } },
      }),
      fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllBizparByParam,
        setError: setError,
        menuName: menuName,
        args: { paramFilters: { bizparCategory: "HOBBY_TYPE" } },
      }),
      fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllBizparByParam,
        setError: setError,
        menuName: menuName,
        args: { paramFilters: { bizparCategory: "INTEREST_TYPE" } },
      }),
    ]);
    if (responses[0].ok && !R.isEmpty(responses[0].data.data)) {
      this.setDataOptions(
        "genderOptions",
        responses[0].data.data.map((item) =>
          mapToObjectDDL(item.value, item.key)
        )
      );
    }
    if (responses[1].ok && !R.isEmpty(responses[1].data.data)) {
      this.setDataOptions(
        "religionOptions",
        responses[1].data.data.map((item) =>
          mapToObjectDDL(item.value, item.key)
        )
      );
    }
    if (responses[2].ok && !R.isEmpty(responses[2].data.data)) {
      this.setDataOptions(
        "jobOptions",
        responses[2].data.data.map((item) =>
          mapToObjectDDL(item.value, item.key)
        )
      );
    }
    if (responses[3].ok && !R.isEmpty(responses[3].data.data)) {
      this.setDataOptions(
        "hobbyOptions",
        responses[3].data.data.map((item) =>
          mapToObjectDDL(item.value, item.key)
        )
      );
      this.setDataOptions(
        "hobbyRaw",
        responses[3].data.data
      );
    }
    if (responses[4].ok && !R.isEmpty(responses[4].data.data)) {
      this.setDataOptions(
        "interestOptions",
        responses[4].data.data.map((item) =>
          mapToObjectDDL(item.value, item.key)
        )
      );
      this.setDataOptions(
        "interestRaw",
        responses[4].data.data
      );
    }
    onTriggerLoading();
  };

  checkFUProspect = async () => {
      const { setError, onTriggerLoading, controls } = this.props;
      
      onTriggerLoading();
      const request = {
        nik: controls.nik?.value,
        category: controls.category?.value?.value,
      };
      if (controls.prospectId.value) {
        request.prospectId = controls.prospectId.value;
      }

      let res = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_TRANSACTION").checkFUProspect,
        menuName: "CRM H23 - Follow Up Prospek",
        setError: setError,
        args: request,
      });
      if (res.ok) {
        if (res.data.data.status) {
          this.handleAlertInfoVisibility(
            "Informasi",
            <div>
              <p>Data Customer sudah memiliki prospek dengan</p>
              <p>{`nomor Prospek : ${res.data.data.prospectId}`}</p>
              <p>Penambahan prospek diabaikan</p>
            </div>
          );
        } else {
          this.handleCheckNIK();
        }
      }
      onTriggerLoading();
  };

  handleAlertInfoVisibility = (title, content, type, additionalData) => {
    this.setState((prev) => ({
      ...prev,
      alertInfo: {
        ...prev.alertInfo,
        visible: !prev.alertInfo.visible,
        title: title,
        content: content,
        type: type || "info",
        additionalData: additionalData,
      },
    }));
  };
  
  handleCheckNIK = async () => {
    const { onTriggerLoading, setError, controls, setValue } = this.props;

    onTriggerLoading();
    let res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").checkNIKForFU,
      menuName: "CRM - Follow Up Prospect",
      setError: setError,
      args: controls.nik.value,
    });
    if (res.ok && !R.isNil(res.data.data)) {
      let data = res.data.data;

      setValue("name", data.nama);
      setValue("nik", data.nik);
      setValue("address", data.alamat);
      setValue(
        "provinceId",
        mapToObjectDDL(data.province.provinceName, data.province.id)
      );
      setValue(
        "kabkotId",
        mapToObjectDDL(data.kabkot.kabKotName, data.kabkot.kabKotId)
      );
      setValue(
        "kecamatanId",
        mapToObjectDDL(data.kecamatan.kecamatanName, data.kecamatan.id)
      );
      setValue(
        "kelurahanId",
        mapToObjectDDL(data.kelurahan.kelurahanname, data.kelurahan.id)
      );
      setValue("zipcode", mapToObjectDDL(data.kodePos, data.kodePos));
      setValue(
        "gender",
        mapToObjectDDL(data.jenisKelamin.value, data.jenisKelamin.key)
      );
      setValue(
        "job1",
        mapToObjectDDL(data.pekerjaan1.value, data.pekerjaan1.key)
      );
      setValue(
        "job2",
        R.isNil(data.pekerjaan2)
          ? null
          : mapToObjectDDL(data?.pekerjaan2?.value, data?.pekerjaan2?.key)
      );
      setValue("religion", mapToObjectDDL(data.agama.value, data.agama.key));
      setValue("hpNumber1", data?.prospect?.hpNumber1);
      setValue("hpNumber2", data?.prospect?.hpNumber2);
      setValue("email", data?.prospect?.email);
      setValue("facebook", data?.prospect?.facebook);
      setValue("instagram", data?.prospect?.instagram);
      setValue("linkedin", data?.prospect?.linkedin);
      setValue("twitter", data?.prospect?.x);
      setValue("tiktok", data?.prospect?.tiktok);
      setValue(
        "discCategory",
        R.isNil(data?.prospect?.discountCategory)
          ? null
          : mapToSelectOption(data?.prospect?.discountCategory)
      );
      setValue(
        "hobby",
        data?.prospect?.hobby?.map((item) =>
          mapToObjectDDL(item.value, item.key)
        )
      );
      setValue(
        "interest",
        data?.prospect?.interest?.map((item) =>
          mapToObjectDDL(item.value, item.key)
        )
      );
      setValue("customerId", data?.prospect?.member?.customerId);
      setValue(
        "memberLevel",
        data?.prospect?.member?.memberLevel
          ? mapToSelectOption(data?.prospect?.member?.memberLevel)
          : null
      );
      setValue(
        "loyaltyLevel",
        data?.prospect?.member?.loyaltyMember
          ? mapToSelectOption(data?.prospect?.member?.loyaltyMember)
          : null
      );
      setValue("specialNotes", data?.prospect?.member?.specialNotes);
      setValue("photoCustomerUrl", data?.prospect?.member?.photoCustomerUrl);
      setValue("prospectId", data?.prospectId);
      setValue("kodeCabang", data?.kodeCabang?.kodeCabang);
      setValue("prospectDate", data?.prospectDate);
      setValue(
        "source",
        prospekSourceOptions.find(
          (item) => item.value === data?.prospect?.prospectSource
        )
      );
      setValue(
        "type",
        prospekTypeOptions.find((item) => item.value === data?.prospect?.type)
      );
      setValue("lastFollowUpBy", data?.prospect?.lastUpdateByUser?.name);
      setValue("prospectOwnership", data?.prospect?.userProspectOwner?.name);
      setValue("lastSeller", data?.prospect?.userLastSeller?.name);
      setValue("sourceCabang", data?.prospect?.sourceCabang?.namaDealer);
    }
    onTriggerLoading();
  };

  setDataOptions = (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      options: {
        ...prevValue.options,
        [name]: value,
      },
    }));
  };

  handleSubmit = () => {
    const { validate, onSubmit, controls, selectedCabang, auth } = this.props;
    const {options} = this.state
    if (validate()) {
      const payload = constructPayloadSubmit({
        controls: flattenFormGroupObject(controls),
        selectedCabang: selectedCabang,
        hobbyRaw: options.hobbyRaw,
        interestRaw: options.interestRaw,
        auth: auth
      })
      onSubmit(flattenFormGroupObject(controls), payload);
    }
  };

  render() {
    const { options, alertInfo } = this.state;
    const {
      activityType,
      tab,
      title,
      visible,
      onClickClose,
      onDeleteProspect,
      initialValues,
    } = this.props;

    const isShowSimpan = activityType === ACTIVITY_TYPE.CREATE;

    const isViewOrDelete =
      activityType === ACTIVITY_TYPE.VIEW ||
      activityType === ACTIVITY_TYPE.DELETE;

    const isShowDeleteButton =
      (tab === "ONGOING" || tab === "PENDING") &&
      activityType === ACTIVITY_TYPE.DELETE;

    return (
      <SimpleModal
        title={title}
        visible={visible}
        onClickClose={() => onClickClose()}
        content={
          <ModalContainer>
            <Tabs>
              <TabList>
                <Tab>Data KTP</Tab>
                <Tab>Data Tambahan</Tab>
                <Tab>Data Member</Tab>
                <Tab>Data Sistem</Tab>
              </TabList>
              <TabPanel>
                <CrmKTP
                  {...this.props}
                  options={options}
                  onClickCheck={this.checkFUProspect}
                />
              </TabPanel>
              <TabPanel>
                <CrmTambahan {...this.props} options={options} />
              </TabPanel>
              <TabPanel>
                <CrmMember {...this.props} options={options} />
              </TabPanel>
              <TabPanel>
                <CrmSystem {...this.props} options={options} box="FU" />
              </TabPanel>
            </Tabs>
            {isShowSimpan && (
              <FlexView style={{ justifyContent: "end", marginTop: "20px" }}>
                <SimpleButton onClick={this.handleSubmit}>Simpan</SimpleButton>
              </FlexView>
            )}
            {isViewOrDelete && <CrmFollowUpHistory {...this.props} />}
            {isShowDeleteButton && (
              <FlexView style={{ justifyContent: "end" }}>
                <SimpleButton
                  onClick={() => onDeleteProspect(initialValues.prospectId)}
                >
                  DELETE
                </SimpleButton>
              </FlexView>
            )}
            {alertInfo?.visible && (
                      <SimpleAlert
                        title={alertInfo?.title}
                        content={<p>{alertInfo?.content}</p>}
                        visible={alertInfo?.visible}
                        onClickClose={() => this.handleAlertInfoVisibility()}
                        additionalButtons={
                          (
                            <SimpleButton
                              type="button"
                              text="OK"
                              onClick={() => this.handleAlertInfoVisibility()}
                            />
                          ) 
                        }
                      />
                    )}
          </ModalContainer>
        }
      />
    );
  }
}

export default withFormGroup(CrmFollowUpH23Modifying);
